






















import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class SearchBar extends Vue {
  private searchString: string = '';
  private searchActive: boolean = false;

  @Prop() private onInputHandler: any;
  @Prop() private onSearch: any;
  @Prop({ default: 'Search' }) private placeholder!: string;

  private doSearch() {
    if (this.onSearch) {
      this.onSearch(this.searchInput);
    } else if (this.onInputHandler) {
      this.onInputHandler(this.searchInput);
    }
    this.searchActive = !!this.searchInput;
    this.$emit('activeSearch', this.searchActive);
  }

  private clearSearch() {
    this.searchString = '';
    this.doSearch();
  }

  private onInput(e: KeyboardEvent) {
    if (this.onInputHandler) {
      this.onInputHandler(this.searchInput);
      this.searchActive = true;
    } else {
      this.searchActive = false;
    }
  }

  get searchInput() {
    return this.searchString || '';
  }
}
